/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormAuditAssignResponseDto } from '../../models/form-audit-assign-response-dto';

export interface BulkUnassignFormAuditor$Params {
  programId: string;
  body: Array<string>;
}

export function bulkUnassignFormAuditor(
  http: HttpClient,
  rootUrl: string,
  params: BulkUnassignFormAuditor$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormAuditAssignResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, bulkUnassignFormAuditor.PATH, 'delete');
  if (params) {
    rb.path('programId', params.programId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormAuditAssignResponseDto>>;
    })
  );
}

bulkUnassignFormAuditor.PATH = '/auditing/bulk/forms/assignment/{programId}';
